import type { BreadcrumbLink } from "../../Breadcrumb/Breadcrumb.types";
import { Wizard } from "@certa/icons/components/Wizard";
import { App } from "@certa/icons/components/App";
import {
  getAIAppBuilderRoute,
  getStudioAppDetailsRoute,
  getStudioGenericRoute,
  getStudioObjectsRouteWithoutStage,
  isAppDetailsPage,
  isEmptyAppDetailsPage,
  isStudioObjectsPage
} from "../../../utils/routes";
import { Database } from "@certa/icons/components/Database";

const appListBreadcrumbLink: BreadcrumbLink = {
  label: "App list",
  url: getStudioGenericRoute()
};

const createAppBreadcrumbLink: BreadcrumbLink = {
  label: "Create app",
  leftIcon: Wizard,
  url: getAIAppBuilderRoute()
};

const recordsBreadcrumbLink: BreadcrumbLink = {
  label: "Records",
  leftIcon: Database,
  url: getStudioObjectsRouteWithoutStage()
};

type AppDetailsBreadcrumbLink = {
  appName: string | undefined;
  appId: number | undefined;
  branchId: number | undefined;
  savepointId: number | undefined;
};

const appDetailsBreadcrumbLink = ({
  appName = "",
  appId = 0,
  branchId = 0,
  savepointId = 0
}: AppDetailsBreadcrumbLink): BreadcrumbLink => ({
  label: appName,
  leftIcon: App,
  url: getStudioAppDetailsRoute({
    id: appId,
    branch: branchId,
    savepoint: savepointId
  })
});

type GetBreadcrumbLinksParams = {
  currentPath: string;
} & AppDetailsBreadcrumbLink;

export const getBreadcrumbLinks = ({
  appName = "",
  appId = 0,
  branchId = 0,
  savepointId = 0,
  currentPath
}: GetBreadcrumbLinksParams) => {
  if (currentPath === getStudioGenericRoute()) {
    return [appListBreadcrumbLink];
  } else if (currentPath === getAIAppBuilderRoute()) {
    return [appListBreadcrumbLink, createAppBreadcrumbLink];
  } else if (isStudioObjectsPage(currentPath)) {
    return [appListBreadcrumbLink, recordsBreadcrumbLink];
  } else if (isAppDetailsPage(currentPath)) {
    return [
      appListBreadcrumbLink,
      appDetailsBreadcrumbLink({
        appName,
        appId,
        branchId,
        savepointId
      })
    ];
  } else if (isEmptyAppDetailsPage(currentPath)) {
    return [
      appListBreadcrumbLink,
      appDetailsBreadcrumbLink({
        appName,
        appId,
        branchId,
        savepointId
      })
    ];
  }
  return [appListBreadcrumbLink];
};
